// extracted by mini-css-extract-plugin
module.exports = {"CandidateEditorWork":"_2eInckFn","EditorWork":"GPPbQ7tN","titleBlock":"S6zehoFb","workHistoryBlock":"_3XFab2fN","title":"_3wLQ_Fer","scrollDiv":"_1kL8JOMa","titleContainer":"Wx02EN8X","autoSaving":"_3iR3tTm6","autoSaved":"_22gHPZVw","saveContent":"Ez1ja4H8","profileLocked":"_30QuqbAP","highlight":"ldLf8Cgi"};
    if(module.hot) {
      // 1754514925242
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  